/**
 * "Open impacted sections" — shown under a chat turn whose agent completed a
 * ``find_impacted_sections`` call; opens the panel for that call's document.
 * Hidden while no run is open (no panel host mounted).
 */

import type React from "react";
import { brandColors, fonts, surfaceColors } from "../tokens";
import { openSourceImpact, useSourceImpactAvailable } from "./sourceImpactBus";

export interface OpenImpactedSectionsButtonProps {
  documentName: string;
}

export const OpenImpactedSectionsButton: React.FC<OpenImpactedSectionsButtonProps> = ({ documentName }) => {
  const available = useSourceImpactAvailable();
  if (!available) return null;
  return (
    <button
      type="button"
      onClick={() => openSourceImpact(documentName)}
      data-testid="open-impacted-sections"
      title={`Open the sections that read ${documentName}`}
      style={{
        alignSelf: "flex-start",
        marginTop: "4px",
        padding: "5px 10px",
        borderRadius: "6px",
        border: `1px solid ${surfaceColors.lineStrong}`,
        background: surfaceColors.paper,
        color: brandColors.primary,
        fontFamily: fonts.body,
        fontSize: "12px",
        fontWeight: 600,
        cursor: "pointer",
        maxWidth: "100%",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      Open impacted sections · {documentName}
    </button>
  );
};

export default OpenImpactedSectionsButton;
